import { Vendors } from '@interfaces/vendor-management-model';

export const columnDefs = [
  {
    field: 'vendorName',
    headerName: 'Vendor',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'totalEmployeesHeadCount',
    headerName: 'Total Headcount',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'hyderabadEmployeesHeadCount',
    headerName: 'Hyd',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'ncremployeesHeadCount',
    headerName: 'NCR',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'remoteEmployeesHeadCount',
    headerName: 'Remote',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'rto',
    headerName: 'RTO',
    filterParams: { hideMenu: true },
    sortParams: { enabled: false },
    cellRenderer: 'customRtoColumn',
  },
];

export const rowData: Vendors[] = [
  {
    vendorName: 'Cognizant',
    totalHeadCount: 18,
    hyd: 5,
    ncr: 13,
    remote: 0,
    regular: 20,
    hybrid: 40,
    partialHybrid: 40,
    vendorId: 1,
  },
  {
    vendorName: 'Harman',
    totalHeadCount: 18,
    hyd: 5,
    ncr: 13,
    remote: 0,
    regular: 30,
    hybrid: 30,
    partialHybrid: 40,
    vendorId: 2,
  },
  {
    vendorName: 'Accolite',
    totalHeadCount: 18,
    hyd: 5,
    ncr: 13,
    remote: 0,
    regular: 25,
    hybrid: 35,
    partialHybrid: 40,
    vendorId: 3,
  },
  {
    vendorName: 'Evry',
    totalHeadCount: 18,
    hyd: 5,
    ncr: 13,
    remote: 0,
    regular: 40,
    hybrid: 30,
    partialHybrid: 30,
    vendorId: 4,
  },
  {
    vendorName: 'M3Bi',
    totalHeadCount: 18,
    hyd: 5,
    ncr: 13,
    remote: 0,
    regular: 35,
    hybrid: 25,
    partialHybrid: 40,
    vendorId: 5,
  },
  {
    vendorName: 'IVL',
    totalHeadCount: 18,
    hyd: 5,
    ncr: 13,
    remote: 0,
    regular: 30,
    hybrid: 40,
    partialHybrid: 30,
    vendorId: 6,
  },
  {
    vendorName: 'Altudo',
    totalHeadCount: 18,
    hyd: 5,
    ncr: 13,
    remote: 0,
    regular: 20,
    hybrid: 50,
    partialHybrid: 30,
    vendorId: 7,
  },
  {
    vendorName: 'Prudent',
    totalHeadCount: 18,
    hyd: 5,
    ncr: 13,
    remote: 0,
    regular: 30,
    hybrid: 30,
    partialHybrid: 40,
    vendorId: 8,
  },
  {
    vendorName: 'Virinchi',
    totalHeadCount: 18,
    hyd: 5,
    ncr: 13,
    remote: 0,
    regular: 40,
    hybrid: 20,
    partialHybrid: 40,
    vendorId: 9,
  },
  {
    vendorName: 'Nagarro',
    totalHeadCount: 18,
    hyd: 5,
    ncr: 13,
    remote: 0,
    regular: 25,
    hybrid: 25,
    partialHybrid: 50,
    vendorId: 10,
  },
  {
    vendorName: 'Mphasis',
    totalHeadCount: 18,
    hyd: 5,
    ncr: 13,
    remote: 0,
    regular: 30,
    hybrid: 40,
    partialHybrid: 30,
    vendorId: 11,
  },
  {
    vendorName: 'Savitr',
    totalHeadCount: 18,
    hyd: 5,
    ncr: 13,
    remote: 0,
    regular: 35,
    hybrid: 35,
    partialHybrid: 30,
    vendorId: 12,
  },
  {
    vendorName: 'Techstar',
    totalHeadCount: 18,
    hyd: 5,
    ncr: 13,
    remote: 0,
    regular: 40,
    hybrid: 30,
    partialHybrid: 30,
    vendorId: 13,
  },
  {
    vendorName: 'Eminent',
    totalHeadCount: 18,
    hyd: 5,
    ncr: 13,
    remote: 0,
    regular: 25,
    hybrid: 25,
    partialHybrid: 50,
    vendorId: 14,
  },
  {
    vendorName: 'Techsofya',
    totalHeadCount: 18,
    hyd: 5,
    ncr: 13,
    remote: 0,
    regular: 30,
    hybrid: 30,
    partialHybrid: 40,
    vendorId: 15,
  },
];
